// removed by extract-text-webpack-plugin
module.exports = {"calendar-form":"src-modules-accommodation-AccommodationCalendarView-__CalendarForm__calendar-form--GggWs"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/accommodation/AccommodationCalendarView/CalendarForm.less
// module id = 1870
// module chunks = 0